{"rating":"4.9","reviewCount":"141","fetchedAt":"2026-10-20T12:59:19.288Z","source":"place-details"}